module.exports = __webpack_public_path__ + "img/portrait-072.38b97299.jpg";